import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { GzDialog } from '../../../../ui/gzDialog/component/GzDialog';
import { translateFn } from '../../../../utils/translator.helper';
import { GzIsolateEndpointTaskWebComponent } from './gzIsolateEndpointTask';
import { CreateTaskRequest } from '../../types';
import { TaskType } from '../../../../tasks/networkTasks/types';
import { IsolateEndpointTaskSpecifics } from './types';

export class IsolateEndpointPopUp extends NetworkBasePopUp<GzIsolateEndpointTaskWebComponent> {
  protected extraDialogConfigs: Partial<GzDialog> = {
    isWindow: false,
  };
  protected title = translateFn('Isolate endpoint');
  protected transformToTaskTarget = true;

  protected customSetup(): void {
    this.popUpContent = new GzIsolateEndpointTaskWebComponent();
  }

  protected async handleConfirmButtonClicked(event: CustomEvent): Promise<void> {
    if (!this.data.targets) {
      throw new Error('Targets are not defined');
    }

    const endpointId = this.data.targets[0].specifics.endpointId;

    if (!endpointId) {
      throw new Error(`EndpointId is not defined for protected entity ${this.data.targets[0]._id}`);
    }

    const request: CreateTaskRequest<IsolateEndpointTaskSpecifics> = {
      settings: {
        specifics: {
          endpointId: endpointId,
          isolate: true,
        },
        taskName: this.getTaskName(),
        targets: this.data.targets,
        type: TaskType.TASK_TYPE_ISOLATE_ENDPOINT_PARENT,
      },
    };

    await this.createTask<IsolateEndpointTaskSpecifics>(request);
  }

  private getTaskName(): string {
    return translateFn('Isolate endpoint {date}', { date: new Date().toISOString().split('T')[0] });
  }
}
